<template>
  <pop-sticky-bar>
    <div slot="main">
      <i-list-multi-select
        name="multiple-select-list"
        :item-groups="options"
        :matcher="listItemMatcher"
        :value="value"
        group-selectable
        @input="onChange"
      />
    </div>
    <div slot="actions" class="action-bar">
      <button class="action-bar__btn" @click="onReset">{{ $t('general.reset') }}</button>
      <button class="action-bar__btn--outline" @click="onConfirm">{{ $t('general.confirm') }}</button>
    </div>
  </pop-sticky-bar>
</template>

<script>
import ListMultiSelectInput from '../../input/select/listMultiSelectInput'
import { matchItemByItemShortCode } from '../../../libs/mapping'
import PopupStickyBar from '../../popup/popupStickyBar'

export default {
  components: {
    'i-list-multi-select': ListMultiSelectInput,
    'pop-sticky-bar': PopupStickyBar,
  },
  data() {
    return {
      /**
       * List selected item matcher function
       */
      listItemMatcher: matchItemByItemShortCode,
    }
  },
  methods: {
    /**
     * on value change
     */
    onChange(newValue) {
      if (Array.isArray(newValue)) {
        this.$emit('input', newValue)
      }
    },
    /**
     * confirm button is clicked
     */
    onConfirm() {
      this.$emit('confirm')
    },
    /**
     * reset button is clicked
     */
    onReset() {
      this.$emit('reset')
    },
  },
  props: {
    /**
     * all selection options
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * selected value
     */
    value: {
      default: () => [],
      type: Array,
    },
  },
}
</script>

<style lang="postcss" scoped>
.popup {
  @apply rounded-xl;
}

.action-bar {
  @apply flex justify-end;

  & .action-bar__btn {
    @apply text-grey-900 px-3 mr-4;
    @apply outline-none border-none;
  }
  & .action-bar__btn--outline {
    @apply text-red-500 px-3 py-1;
    @apply border border-red-500 rounded outline-none;
  }
}
</style>
